export default __webpack_public_path__ + "static/mobile-image-97181876f1304900b8e3a70860fe9b0b.png";